function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 13.5,
    viewBox: "0 0 13.5 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "download (3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46873",
    d: "M15 15v2.667A1.333 1.333 0 0 1 13.667 19H4.333A1.333 1.333 0 0 1 3 17.667V15",
    transform: "translate(-2.25 -6.25)",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14520"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46874",
    d: "M7 13.333 10.333 10l3.333 3.333",
    transform: "translate(-3.583 -9.25)",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 205",
    transform: "translate(6.751 .75)",
    style: {
      fill: "none",
      stroke: "#2973f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.33528b979aed940a31c98db9ce8c2377.svg";
export { ForwardRef as ReactComponent };